import { render, staticRenderFns } from "./cloud.vue?vue&type=template&id=48f491f1&scoped=true&"
import script from "./cloud.vue?vue&type=script&lang=js&"
export * from "./cloud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f491f1",
  null
  
)

export default component.exports